import { useQuery } from '@tanstack/react-query'
import { toast } from 'sonner'
import { queryKeys } from '@/shared/constants/query-keys'
import { getErrorMessage } from '@/shared/utils/handle-api-error'
import type { ITypeProperty, ITypePropertyById } from '../models/type-property'
import { typePropertiesService } from '../services/type-properties.services'

/**
 * Lookups legacy para consumidores fuera del catálogo (editor de plantillas,
 * form de inmuebles, filtro de inventario). La tabla admin usa
 * use-type-properties-admin-query.
 */

export const useTypePropertyByIdQuery = ({
  id,
  dependence = true
}: {
  id: string | null | undefined
  dependence?: boolean
}) => {
  return useQuery<ITypePropertyById | null>({
    queryKey: queryKeys.typeProperties.detail(id ?? ''),
    queryFn: async () => {
      try {
        if (!id) return null
        return await typePropertiesService.getById(id)
      } catch (error) {
        console.error(error)
        toast.error(getErrorMessage(error))
        return null
      }
    },
    enabled: dependence,
    refetchOnWindowFocus: false
  })
}

export const useTypePropertyByProjectIdQuery = ({
  id,
  dependence = true
}: {
  id: string | null | undefined
  dependence?: boolean
}) => {
  return useQuery<ITypeProperty[]>({
    queryKey: queryKeys.typeProperties.byProject(id ?? ''),
    queryFn: async () => {
      try {
        if (!id) return []
        return await typePropertiesService.getByProjectId(id)
      } catch (error) {
        console.error(error)
        toast.error(getErrorMessage(error))
        return []
      }
    },
    enabled: dependence,
    refetchOnWindowFocus: false
  })
}
